import * as action_types from '../actions/action_types';

const initialState = {
  isShowing: false,
  alertId: 0, // key of app type
  alertType: '', // app type
  data: [],
};

export const NotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case action_types.HIDE_SHOW_NOTES:
      return Object.assign({}, state, {
        isShowing: action.data.isShowing,
        alertId: action.data.alertId,
        alertType: action.data.alertType,
      });
    case action_types.GET_NOTES_BY_ALERTID_AND_ALERTTYPE:
      return Object.assign({}, state, {
        data: action.payload,
      });
    case action_types.SAVE_NOTES:
      return Object.assign({}, state, {
        data: action.payload,
      });
    default:
      return state;
  }
};
